import * as CarouselProgressBar from './App/CarouselProgressBar';
import * as Lightgallery from './Spinao/Lightgallery';

$(document).ready(function () {
    Lightgallery.applyTo('[data-lightgallery]', {
        selector:'.js-lightgallery-image',
        fullScreen:false,
        zoom:false,
        hash:false,
        pager:false
    });

    CarouselProgressBar.initialize();
});
